import { restGet, restPost } from "../../apiCommandsExecutor/rest";
import { NewOrder } from "./models";
import { Order, Coupon, AddressSuggestion } from "./models";
import { PriceInCurrency, Table } from "../menu/models";

export interface OrderCreatedRest {
    orderId: number;
    clientId: number | null;
}

export interface OrderWithTableRest {
    order: Order;
    table: Table | null;
}

export interface DeliveryPriceRest {
    isAddressInDeliveryZone: boolean;
    freeDeliveryMinimalOrderPrice: PriceInCurrency | null;
    fixedDeliveryPrice: PriceInCurrency | null;
}

class OrdersRestService {
    static async createOrder(newOrder: NewOrder) {
        return restPost<OrderCreatedRest>("/orders", newOrder);
    }

    static async getOrder(orderId: number) {
        return restGet<OrderWithTableRest>(`/orders/${orderId}`);
    }

    static async getCoupon(couponCode: string, menuId: number) {
        return restGet<Coupon>(`/coupons/${encodeURIComponent(couponCode)}`, { menuId });
    }

    static async getAddressSuggestions(menuId: number, query: string) {
        return restGet<AddressSuggestion[]>("/address-suggestions", { menuId, query });
    }

    static async getDeliveryPrice(menuId: number, latitude: number, longitude: number) {
        return restGet<DeliveryPriceRest>("/delivery-price", { menuId, latitude, longitude });
    }
}

export default OrdersRestService;
